import { Sha256 } from '@aws-crypto/sha256-js';
import fetch from "./sessionFetch";
import { authHeaders, baseUrl } from './apiUtils';

async function request(path, method = 'GET', body) {
  const response = await fetch(`${baseUrl}${path}`, { method,
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    ...(body ? { body: JSON.stringify(body) } : {}) });
  let result;
  try { result = await response.json(); } catch (error) { result = {}; }
  if (!response.ok) {
    throw Object.assign(
      new Error((result.error && result.error.message) || 'Nie udało się wykonać operacji. Spróbuj ponownie.'),
      { status: response.status, code: result.error && result.error.code, field: result.error && result.error.field },
    );
  }
  return result;
}
const id = value => {
  if (typeof value !== 'string' || !/^[A-Za-z0-9_@.+:-]{1,180}$/.test(value)) throw new Error('Nieprawidłowy identyfikator.');
  return encodeURIComponent(value);
};
const reportPath = ({ platform, schoolId, reportId }) => (platform ? `platform/support/schools/${id(schoolId)}/reports/${id(reportId)}` : `support/reports/${id(reportId)}`);
const queryString = query => {
  const params = new URLSearchParams();
  Object.keys(query).forEach(key => { if (query[key] !== undefined && query[key] !== null && query[key] !== '') params.set(key, query[key]); });
  return params.toString();
};
async function upload(file) {
  const bytes = await file.arrayBuffer();
  const digest = new Sha256();
  digest.update(new Uint8Array(bytes));
  const hash = await digest.digest();
  const checksum = Array.from(new Uint8Array(hash)).map(value => value.toString(16).padStart(2, '0')).join('');
  const intent = await request('support/uploads', 'POST', { contentType: file.type, size: file.size, checksum });
  let body = file;
  if (intent.method !== 'PUT') {
    body = new FormData();
    Object.keys(intent.fields).forEach(key => body.append(key, intent.fields[key]));
    body.append('file', file);
  }
  const url = intent.url.startsWith('/') ? new URL(intent.url, baseUrl).href : intent.url;
  let response;
  try {
    response = await fetch(url, { method: intent.method || 'POST', body });
  } catch (error) {
    throw Object.assign(new Error('Nie udało się przesłać obrazu. Ponów próbę lub usuń załącznik.'), { code: 'UPLOAD_FAILED' });
  }
  if (!response.ok) throw Object.assign(new Error('Nie udało się przesłać obrazu. Ponów próbę lub usuń załącznik.'), { code: 'UPLOAD_FAILED' });
  return intent.uploadId;
}
export default {
  getCapabilities: () => request('support/capabilities'),
  createReport: body => request('support/reports', 'POST', body),
  listReports: ({ platform = false, ...query } = {}) => request(`${platform ? 'platform/' : ''}support/reports?${queryString(query)}`),
  getReport: target => request(reportPath(target)),
  listEvents: (target, cursor) => request(`${reportPath(target)}/events?${queryString({ cursor })}`),
  addMessage: (target, body) => request(`${reportPath(target)}/messages`, 'POST', body),
  changeStatus: (target, body) => request(`${reportPath(target)}/status`, 'PATCH', body),
  getAttachment: target => request(`${reportPath(target)}/attachment`).then(result => ({ ...result, url: new URL(result.url, baseUrl).href })),
  upload,
};
